// src/components/common/QuickService.jsx
import React from 'react';

const QuickService = ({ icon, text, color, onClick }) => (
  <div 
    className={`flex flex-col items-center justify-center p-3 ${color} rounded-xl cursor-pointer shadow-sm border border-gray-100`}
    onClick={onClick}
  >
    <div className="mb-2">{icon}</div>
    <p className="text-xs font-medium text-gray-700">{text}</p>
  </div>
);

export default QuickService;